import {
  CustomQuestionAnswerEntity,
  CustomQuestionEntity,
} from 'libs/shared/custom-question/src/lib/custom-question.models'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import { Observable } from 'rxjs'
import { BaseEventTicketEntity } from '../../event-tickets/data-access/src/lib/+state/base-event-tickets.models'
import { InjectionToken } from '@angular/core'

export const EVENT_TICKET_PURCHASES_FACADE = new InjectionToken<SharedEventTicketPurchasesFacade>(
  'EventTicketPurchasesFacade',
)

export interface SharedEventTicketPurchasesFacade extends GbBaseFacade {
  selectedPurchaseId$: Observable<string | undefined>
  selectedPurchaseEventTickets$: Observable<BaseEventTicketEntity[]>
  selectedPurchaseCustomQuestions$: Observable<CustomQuestionEntity[]>
  profileRegistrationCustomQuestionAnswers$: Observable<CustomQuestionAnswerEntity[]>
}
